import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'middleEllipsisPath',
  standalone: false,
})
export class MiddleEllipsisPathPipe implements PipeTransform {
  transform(path: string | null | undefined): string {
    if (!path) return '';
    const trimmedPath = path.trim();

    const parts = trimmedPath
      .split(/\s*\/\s*/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);

    if (parts.length <= 2) {
      return parts.join(' / ');
    }

    return `${parts[0]} / … / ${parts[parts.length - 1]}`;
  }
}
